module.exports = __webpack_public_path__ + "static/media/introducing-reviewdale.1c81fe18.svg";